module.exports = __webpack_public_path__ + "static/support-915c74cf44dcc35bab3a8ca004fabbdf.jpg";